import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Solar Panel 400W",
        price: 50.00,
        disprice: 70.00,
        stock: 9,
        content: "Harness the power of the sun with our efficient Solar Panel 400W, designed to deliver reliable energy output for your home, business, or outdoor projects.",
        description: "The Solar Panel 400W offers high energy efficiency and durability, making it ideal for various applications including residential, commercial, and off-grid systems. Built to withstand harsh weather conditions, it ensures consistent power generation year-round.",
        category: ["Renewable Energy", "Solar Equipment"],
        tags: ["Solar", "Panel", "Hybrid"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Output", content: "400 Watts" },
            { id: 2, title: "Material", content: "Monocrystalline Silicon" },
            { id: 3, title: "Dimensions", content: "39 x 21 x 1.2 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Daniel Davis",
                date: "May 5, 2024",
                rating: 5,
                content: "Impressive performance and easy to install. Perfect for my cabin setup!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emma Rodriguez",
                date: "May 6, 2024",
                rating: 5,
                content: "Solid build quality and great output even on cloudy days."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Solar Panel 200W",
        price: 50,
        disprice: 70,
        stock: 5,
        content: "Efficiently harness solar energy with our 200W Solar Panel, perfect for home, RV, and off-grid applications. Designed for high performance and durability, it ensures reliable power output even in challenging conditions.",
        description: "Our 200W Solar Panel delivers dependable renewable energy for a variety of uses. Built with high-efficiency monocrystalline cells, it offers excellent sunlight conversion, weather resistance, and long-lasting performance. Ideal for powering devices, charging batteries, and reducing electricity costs.",
        category: ["Renewable Energy", "Solar Equipment"],
        tags: ["Solar", "Panel", "Hybrid"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Efficiency Monocrystalline Cells" },
            { id: 2, title: "Power Output", content: "200W Rated" },
            { id: 3, title: "Weight", content: "15 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Alex Johnson",
                date: "June 10, 2024",
                rating: 5,
                content: "Compact size with great power output. Works perfectly for my RV setup."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Sophia Lee",
                date: "June 12, 2024",
                rating: 5,
                content: "Solid build quality and easy installation. Highly efficient!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Wind Turbine",
        price: 50,
        disprice: 70,
        stock: 3,
        content: "Generate clean, renewable energy with our compact Wind Turbine, designed for homes, cabins, and remote locations. Reliable performance even in low-wind conditions.",
        description: "Our Wind Turbine is engineered for efficiency and durability, converting wind into usable electricity with minimal maintenance. Ideal for off-grid applications, it features weather-resistant materials and a lightweight design for easy installation.",
        category: ["Renewable Energy", "Power Solutions"],
        tags: ["Wind", "Generator", "Power"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Weather-Resistant Aluminum and Fiberglass" },
            { id: 2, title: "Power Output", content: "Rated 500W at Optimal Wind Speed" },
            { id: 3, title: "Weight", content: "20 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Daniel Smith",
                date: "July 5, 2024",
                rating: 5,
                content: "Great for my cabin in the hills. Steady power generation even on mild days."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Mia Clark",
                date: "July 7, 2024",
                rating: 4,
                content: "Performs well and is quieter than I expected. Very satisfied."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Street Charger",
        price: 50,
        disprice: 70,
        stock: 0,
        content: "Power your devices anywhere with our Solar Street Charger, ideal for public spaces, parks, and outdoor areas. Eco-friendly and cost-efficient.",
        description: "The Solar Street Charger harnesses sunlight to provide free charging for mobile devices. Built with durable, weatherproof materials, it operates efficiently in various conditions and supports multiple charging ports for public convenience.",
        category: ["Solar Equipment", "Power Solutions"],
        tags: ["Solar", "Street", "Charger"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Powder-Coated Steel and Tempered Glass" },
            { id: 2, title: "Charging Ports", content: "4 USB Fast-Charging Ports" },
            { id: 3, title: "Solar Capacity", content: "150W Monocrystalline Panel" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Olivia Johnson",
                date: "July 12, 2024",
                rating: 5,
                content: "Perfect for our community park. People love the convenience."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Liam Brown",
                date: "July 14, 2024",
                rating: 4,
                content: "Works great and easy to install. Would recommend for public spaces."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Sun Light",
        price: 50,
        disprice: 70,
        stock: 8,
        content: "Illuminate your outdoor spaces with our eco-friendly Sun Light, powered entirely by solar energy for cost-free operation.",
        description: "The Sun Light provides bright, reliable lighting using energy harnessed from the sun. Its durable, weather-resistant design ensures optimal performance year-round, making it perfect for gardens, pathways, and patios.",
        category: ["Solar Equipment", "Outdoor Gear"],
        tags: ["Solar", "Light", "Outdoor"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "ABS Plastic and Tempered Glass" },
            { id: 2, title: "Brightness", content: "800 Lumens" },
            { id: 3, title: "Battery", content: "Rechargeable Lithium-ion 2000mAh" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Sophia Green",
                date: "August 3, 2024",
                rating: 5,
                content: "Beautiful lighting for my garden, and no extra electricity cost!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "James Miller",
                date: "August 5, 2024",
                rating: 4,
                content: "Works great, even during cloudy days. Would recommend."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Hybrid Tech",
        price: 50,
        disprice: 70,
        stock: 6,
        content: "Experience cutting-edge performance with our Hybrid Tech, combining solar and electric power for versatile usage.",
        description: "Hybrid Tech integrates solar and traditional electric power sources, offering flexibility, energy savings, and eco-friendly operation. Perfect for households or businesses seeking a reliable and sustainable energy solution.",
        category: ["Energy Devices", "Power Solutions"],
        tags: ["Hybrid", "Electronics", "Power"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Source", content: "Solar + AC Power" },
            { id: 2, title: "Output", content: "200W Continuous" },
            { id: 3, title: "Warranty", content: "2 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ethan Wright",
                date: "August 6, 2024",
                rating: 5,
                content: "Very efficient and reliable, great for backup power."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Mia Johnson",
                date: "August 8, 2024",
                rating: 4,
                content: "The hybrid function is super useful during power cuts."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Solar Charger",
        price: 50,
        disprice: 70,
        stock: 2,
        content: "Stay powered on the go with our Solar Charger, designed for quick and efficient charging using sunlight.",
        description: "The Solar Charger is perfect for outdoor enthusiasts, travelers, or anyone needing portable, eco-friendly power. Its compact design ensures easy carrying while providing reliable charging for phones, tablets, and small devices.",
        category: ["Solar Equipment", "Energy Devices"],
        tags: ["Solar", "Charger", "Electronics"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Output", content: "15W" },
            { id: 2, title: "Port Type", content: "USB-A & USB-C" },
            { id: 3, title: "Warranty", content: "1 Year" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Daniel Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Perfect for camping trips. Charges my phone fast!"
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Sophia Lee",
                date: "August 12, 2024",
                rating: 4,
                content: "Compact and works well even on cloudy days."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Solar Module",
        price: 50,
        disprice: 70,
        stock: 0,
        content: "Efficient and durable Solar Module designed to convert sunlight into reliable energy for various applications.",
        description: "Our Solar Module offers high conversion efficiency, making it perfect for residential, commercial, and off-grid setups. Built with weather-resistant materials, it ensures long-lasting performance in all conditions.",
        category: ["Renewable Energy", "Solar Equipment"],
        tags: ["Solar", "Module", "Panel"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Output", content: "200W" },
            { id: 2, title: "Dimensions", content: "1500 x 680 x 35 mm" },
            { id: 3, title: "Warranty", content: "10 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "James Porter",
                date: "August 14, 2024",
                rating: 5,
                content: "Excellent build quality and great performance."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Emily Wright",
                date: "August 15, 2024",
                rating: 4,
                content: "Works perfectly with my off-grid cabin setup."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Solar Water",
        price: 50,
        disprice: 70,
        stock: 10,
        content: "Reliable solar water heating system that provides efficient and sustainable hot water for your home or business.",
        description: "Our Solar Water heater uses advanced solar technology to heat water using renewable energy, reducing utility bills and environmental impact. Ideal for residential and commercial use.",
        category: ["Renewable Energy", "Power Solutions"],
        tags: ["Solar", "Water", "Power"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Capacity", content: "150 Liters" },
            { id: 2, title: "Material", content: "Copper & Stainless Steel" },
            { id: 3, title: "Warranty", content: "5 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Sarah Collins",
                date: "July 10, 2024",
                rating: 5,
                content: "Efficient and reliable solar water heater. Saves on energy costs!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Michael Lee",
                date: "July 12, 2024",
                rating: 4,
                content: "Installation was easy and it works great for my family."
            }
        ]
    },
    {
    id: 10,
    image: images.product10Gallery1,
    name: "Panel 400W",
    price: 50,
    disprice: 70,
    stock: 20,
    content: "High-efficiency 400W solar panel designed to maximize energy output for residential and commercial use.",
    description: "Our 400W solar panel features advanced photovoltaic cells for superior performance and durability. Ideal for powering homes, businesses, and outdoor applications.",
    category: ["Renewable Energy", "Solar Equipment"],
    tags: ["Solar", "Panel", "Power"],
    gallery: {
        image1: images.product10Gallery1,
        image2: images.product10Gallery2,
        image3: images.product10Gallery3,
        image4: images.product10Gallery4,
    },
    addInfo: [
        { id: 1, title: "Power Output", content: "400 Watts" },
        { id: 2, title: "Dimensions", content: "65 x 39 inches" },
        { id: 3, title: "Warranty", content: "25 Years" }
    ],
    comments: [
        {
        id: 1,
        image: images.product10Review1,
        name: "Laura Green",
        date: "August 1, 2024",
        rating: 5,
        content: "Excellent panel with consistent power generation. Highly recommend!"
        },
        {
        id: 2,
        image: images.product10Review2,
        name: "James White",
        date: "August 3, 2024",
        rating: 4,
        content: "Great value for the price and easy to install."
        }
    ]
    },
    {
    id: 11,
    image: images.product11Gallery1,
    name: "Panel 200W",
    price: 50,
    disprice: 70,
    stock: 25,
    content: "Compact and efficient 200W solar panel suitable for small-scale residential and portable applications.",
    description: "Our 200W solar panel delivers reliable energy conversion with a durable design, perfect for RVs, boats, and off-grid setups.",
    category: ["Renewable Energy", "Solar Equipment"],
    tags: ["Solar", "Panel", "Power"],
    gallery: {
        image1: images.product11Gallery1,
        image2: images.product11Gallery2,
        image3: images.product11Gallery3,
        image4: images.product11Gallery4,
    },
    addInfo: [
        { id: 1, title: "Power Output", content: "200 Watts" },
        { id: 2, title: "Dimensions", content: "41 x 20 inches" },
        { id: 3, title: "Warranty", content: "20 Years" }
    ],
    comments: [
        {
        id: 1,
        image: images.product11Review1,
        name: "Sophia Lee",
        date: "July 15, 2024",
        rating: 5,
        content: "Perfect size and performance for my camper van setup."
        },
        {
        id: 2,
        image: images.product11Review2,
        name: "Michael Brown",
        date: "July 18, 2024",
        rating: 4,
        content: "Good power output and easy to mount."
        }
    ]
    },
    {
    id: 12,
    image: images.product12Gallery1,
    name: "Wind Generator",
    price: 50,
    disprice: 70,
    stock: 15,
    content: "Efficient wind generator designed to harness wind energy for residential and small commercial use.",
    description: "Our Wind Generator provides a sustainable and clean power source with durable construction and easy installation, ideal for off-grid and backup power solutions.",
    category: ["Renewable Energy", "Power Solutions"],
    tags: ["Wind", "Generator", "Power"],
    gallery: {
        image1: images.product12Gallery1,
        image2: images.product12Gallery2,
        image3: images.product12Gallery3,
        image4: images.product12Gallery4,
    },
    addInfo: [
        { id: 1, title: "Power Capacity", content: "500 Watts" },
        { id: 2, title: "Blade Diameter", content: "1.2 meters" },
        { id: 3, title: "Warranty", content: "15 Years" }
    ],
    comments: [
        {
        id: 1,
        image: images.product12Review1,
        name: "James Wilson",
        date: "August 10, 2024",
        rating: 5,
        content: "Reliable and quiet wind generator, perfect for my cabin."
        },
        {
        id: 2,
        image: images.product12Review2,
        name: "Laura Mitchell",
        date: "August 12, 2024",
        rating: 4,
        content: "Good power output but installation took some time."
        }
    ]
    },
    {
    id: 13,
    image: images.product13Gallery1,
    name: "Street Charger",
    price: 50,
    disprice: 70,
    stock: 12,
    content: "Durable solar street charger providing efficient outdoor lighting and device charging capabilities.",
    description: "Our Street Charger is designed for urban and rural outdoor use, combining solar energy with robust construction for reliable nighttime lighting and convenient charging stations.",
    category: ["Solar Equipment", "Power Solutions"],
    tags: ["Street", "Charger", "Power"],
    gallery: {
        image1: images.product13Gallery1,
        image2: images.product13Gallery2,
        image3: images.product13Gallery3,
        image4: images.product13Gallery4,
    },
    addInfo: [
        { id: 1, title: "Battery Capacity", content: "12000mAh" },
        { id: 2, title: "Lighting Power", content: "30 Watts LED" },
        { id: 3, title: "Weatherproof", content: "IP65 Certified" }
    ],
    comments: [
        {
        id: 1,
        image: images.product13Review1,
        name: "Sophia Green",
        date: "September 15, 2024",
        rating: 5,
        content: "Perfect for our community park, bright and reliable!"
        },
        {
        id: 2,
        image: images.product13Review2,
        name: "Ethan Hall",
        date: "September 18, 2024",
        rating: 4,
        content: "Good charger with excellent solar performance."
        }
    ]
    },
    {
    id: 14,
    image: images.product14Gallery1,
    name: "Solar Lamp",
    price: 50,
    disprice: 70,
    stock: 20,
    content: "Portable solar lamp offering bright, eco-friendly lighting for outdoor and indoor use.",
    description: "Our Solar Lamp features energy-efficient LED technology powered by solar panels, perfect for camping, emergencies, and everyday use without reliance on electricity.",
    category: ["Solar Equipment", "Outdoor Gear"],
    tags: ["Solar", "Light", "Outdoor"],
    gallery: {
        image1: images.product14Gallery1,
        image2: images.product14Gallery2,
        image3: images.product14Gallery3,
        image4: images.product14Gallery4,
    },
    addInfo: [
        { id: 1, title: "Battery Life", content: "8 hours on full charge" },
        { id: 2, title: "LED Brightness", content: "500 lumens" },
        { id: 3, title: "Charging Time", content: "6 hours sunlight" }
    ],
    comments: [
        {
        id: 1,
        image: images.product14Review1,
        name: "Liam Johnson",
        date: "October 5, 2024",
        rating: 5,
        content: "Bright and long-lasting, great for camping trips!"
        },
        {
        id: 2,
        image: images.product14Review2,
        name: "Mia Wilson",
        date: "October 7, 2024",
        rating: 4,
        content: "Very handy and eco-friendly lamp for daily use."
        }
    ]
    },
    {
    id: 15,
    image: images.product15Gallery1,
    name: "Hybrid Device",
    price: 50,
    disprice: 70,
    stock: 15,
    content: "Multi-functional hybrid device combining solar and electronic technologies for versatile energy solutions.",
    description: "Our Hybrid Device integrates solar power with advanced electronics to provide efficient energy management and backup power for outdoor and home use.",
    category: ["Energy Devices", "Power Solutions"],
    tags: ["Hybrid", "Device", "Electronics"],
    gallery: {
        image1: images.product15Gallery1,
        image2: images.product15Gallery2,
        image3: images.product15Gallery3,
        image4: images.product15Gallery4,
    },
    addInfo: [
        { id: 1, title: "Power Output", content: "100W Solar + 50W Battery" },
        { id: 2, title: "Battery Capacity", content: "5000mAh" },
        { id: 3, title: "Weight", content: "1.2 lbs" }
    ],
    comments: [
        {
        id: 1,
        image: images.product15Review1,
        name: "Sophia Lee",
        date: "November 10, 2024",
        rating: 5,
        content: "Excellent hybrid device, very reliable and efficient."
        },
        {
        id: 2,
        image: images.product15Review2,
        name: "Ethan Kim",
        date: "November 12, 2024",
        rating: 4,
        content: "Great for backup power and solar charging combined."
        }
    ]
    }

];

export default products;